import {observer} from "mobx-react-lite";
import React from "react";
import {
    WAVE_DOT_RADIUS,
    WAVE_HEIGHT,
    WAVE_OFFSET_X_LEFT,
    WAVE_OFFSET_Y,
    WAVE_SVG_HEIGHT,
    WAVE_SVG_WIDTH,
    WAVE_VIEWBOX
} from "../utils/svg";

interface ModulatorWavedDotProps {
    x: number;
    y: number;
}

export const ModulatorWaveDot = observer(({x, y}: ModulatorWavedDotProps) => {

    return (
        <svg width={`${WAVE_SVG_WIDTH}px`} height={`${WAVE_SVG_HEIGHT}px`} viewBox={WAVE_VIEWBOX} className="wave-dot">
            <circle cx={Math.round(x) + WAVE_OFFSET_X_LEFT}
                    cy={WAVE_SVG_HEIGHT - (WAVE_OFFSET_Y + y * WAVE_HEIGHT)}
                    r={WAVE_DOT_RADIUS}
                    className="on" />
        </svg>
    );

});
